import { ReactNode } from "react";
import { SocketProvider } from "../contexts/SocketContext";

interface User {
  id: string;
  email: string;
  name: string | null;
  tenantId: string;
  role: string;
}

interface CollaborationProviderProps {
  children: ReactNode;
  user: User | null;
}

/**
 * Wrapper that provides Socket.IO connection when user is authenticated
 * SECURITY: Authentication happens via httpOnly cookies, no token needed
 *
 * NOTE: Accepts user as prop to avoid duplicate useAuth() subscription
 */
export function CollaborationProvider({ children, user }: CollaborationProviderProps) {
  // Only connect to Socket.IO when user is authenticated
  if (!user) {
    return <>{children}</>;
  }

  return (
    <SocketProvider
      userId={user.id}
      userName={user.name || user.email}
      userAvatar={undefined}
    >
      {children}
    </SocketProvider>
  );
}
